/**
 * Whether a failed request means the user's session is genuinely invalid.
 *
 * Only 401 and 403 do. Everything else — 5xx, gateway errors, request
 * timeouts, DNS/CORS/offline failures (which arrive with no response at all) —
 * is a transient problem on our side, and treating one as an authentication
 * failure signs a teacher out mid-session for a blip they didn't cause.
 *
 * Handles both axios-shaped errors (status under `response`) and errors thrown
 * by Clerk's SDK (status at the top level). An error carrying no status at all
 * is, by definition, not an authentication failure.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export const isAuthenticationFailure = (error) => {
  const status = error?.response?.status ?? error?.status;
  return status === 401 || status === 403;
};
